import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import { api } from "@/lib/api";

export default function BlogList() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setArticles(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-list-page" className="bg-background min-h-screen">
      <Navbar />
      <main className="pt-32 md:pt-40">
        <div className="container-page">
          <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-forest/70 hover:text-terracotta transition-colors mb-8">
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Back to home
          </Link>
          <p className="label-eyebrow">Health Notes</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight text-forest mt-5 leading-[1.05]">
            Articles & guides for <span className="italic text-terracotta">every life stage.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-forest/70 leading-relaxed">
            Honest, careful writing on the questions women in our clinic ask most often — by Dr. Chandrani Jha and the practice.
          </p>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {loading && <p className="text-forest/60">Loading articles…</p>}
            {articles.map((a, i) => (
              <Link
                key={a.slug}
                to={`/articles/${a.slug}`}
                data-testid={`article-${a.slug}`}
                className="card-soft overflow-hidden group block"
                style={{ animation: `fade-up 0.6s ease-out ${i * 60}ms both` }}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={a.cover} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-sage">
                    <span>{a.category}</span>
                    <span className="w-1 h-1 rounded-full bg-sage/50" />
                    <span>{a.read_minutes} min</span>
                  </div>
                  <h3 className="font-serif text-2xl leading-tight text-forest mt-4 group-hover:text-terracotta transition-colors">{a.title}</h3>
                  <p className="mt-3 text-forest/70 leading-relaxed line-clamp-3">{a.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
